import { getAssetUrl } from '../../../utils/config';
import Button from '../../atoms/Button';
import { FormattedMessage } from 'react-intl';
import './style.scss';

type PaymentReviewProps = {
  paymentMethod: string;
};

const PaymentReview = ({ paymentMethod }: PaymentReviewProps) => (
  <div className="payment-review">
    <div className="payment-review__method">
      <img className="payment-review__status-icon" src={getAssetUrl('common/statusSuccess.svg')} alt="success" />
      <img src={getAssetUrl(`payment/${paymentMethod}.svg`)} alt={paymentMethod} />
    </div>
    <Button secondary className="change-payment" id="change-payment">
      <FormattedMessage id="generic.edit" />
    </Button>
  </div>
);

export default PaymentReview;
